import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class DividendAccrualDetailLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public investorName: string = "";

    public investmentRefNo: string = "";

    @Attributes.Float()
    public expectedDividend: number = 0;

    @Attributes.Float()
    public actualDividend: number = 0;

    public reInvest: boolean = false;

    public isDwtExempt: boolean = false;

    @Attributes.Nullable()
    @Attributes.Float()
    public dwtReducedRate: number | null = null;

    public dwtExemptionExpired: boolean = false;

    public dwtExemptionCode: string | null = null;

    // Client only properties / methods

    public get exemptionWarning() {
        if (this.dwtExemptionExpired) {
            if (this.dwtReducedRate !== null) {
                return "Has reduced rate, but expired or missing exemption.";
            } else if (this.dwtExemptionCode !== null) {
                return "Has DWT exemption code, but expired or missing exemption.";
            } else if (this.isDwtExempt) {
                return "Exempt entity type, but expired or missing exemption.";
            }
        }
        return null;
    }
}